import ReactAudioPlayer from "react-audio-player";
import { checkIfHasBadWordsAndSocialMedia } from "../../helpers/et3-text-checker/social-media-and-bad-words";
import Et3Image from "../../core/et3-Image";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import i18n, { Ti18nKeys } from "../../constants/i18n";
import {
  isDefinedArray,
  isDefinedString,
  isPositiveNumber,
  reduce
} from "et3-type-guards";
import Et3Button from "../../core/et3-button";
import { et3ReadableDecimalNumber } from "../../helpers/et3-data-helper";
import configuration from "../../configuration/keys/index";
import { colors } from "../../core/et3-theme/colors";
import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import { getClientReadableText } from "../../helpers/et3-get-client-readable-text";
import ET3Div from "../../core/et3-div";

import { TCorePage } from "../../Types";

import Et3ATag from "../../core/et3-a-tag";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getInvestigationCasesStore from "../../stores/investigation-cases-store";
import getUserMessagesStore from "../../stores/user-store/messages-store";

import {
  DESCRIPTION_EVENTS,
  PICTURE_EVENTS
} from "../../constants/admin-events-constants";
import { getExtraDataParts } from "../../helpers/et3-get-event-list";

export const ClientReadableText = withLiteObserverAndTheme<{ text: string }>(
  (props) => {
    const { text } = props;
    return (
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={15}
        text={getClientReadableText(`${text}`)}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{
          width: "100%",
          textAlign: "center",
          wordWrap: "break-word"
        }}
      />
    );
  }
);

export const ClientReadablePercentage = withLiteObserverAndTheme<{
  value: string;
}>((props) => {
  const { value } = props;
  const numericalValue = parseFloat(value.replace("%", ""));
  const roundedValue = `${et3ReadableDecimalNumber(numericalValue, 2)}`;
  let stringValue = roundedValue;
  if (!stringValue.includes(".")) {
    stringValue = stringValue + ".00";
  }
  const text = `${stringValue}%`;
  return (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={15}
      text={text}
      isSpan={false}
      color={colors.all.black}
      style={{ textAlign: "center" }}
    />
  );
});

export const MessageType = withLiteObserverAndTheme<{
  message: string;
  messageType: string;
}>((props) => {
  const { theme, message, messageType } = props;
  const { colors, unitY, unitX } = theme;
  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(message);
  const textColors = hasBadWords
    ? {
        backgroundColor: colors.all.red,
        textColor: colors.all.white
      }
    : hasSocialMedia
      ? {
          backgroundColor: colors.all.orange,
          textColor: colors.all.white
        }
      : {
          backgroundColor: colors.all.transparent,
          textColor: colors.all.black
        };

  if (messageType === "khotabe_message") {
    const parsedMessage = JSON.parse(`${message}`);
    const messageType = reduce(() => parsedMessage.subType, "");
    const messageText =
      messageType === "LIKE_PROFILE_MESSAGE"
        ? reduce(() => parsedMessage.text, "")
        : message;

    return (
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        text={messageText}
        isSpan={false}
        color={colors.all.black}
        style={{
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          wordWrap: "break-word",
          overflow: "hidden",
          backgroundColor: textColors.backgroundColor
        }}
      />
    );
  }

  if (messageType === "picture")
    return (
      <Et3Image
        type={"ONLINE"}
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={`${message}`}
        size={140}
        onClick={() => {}}
        style={{}}
      />
    );

  if (messageType === "voice")
    return (
      <ReactAudioPlayer
        src={`${message}`}
        autoPlay={false}
        controls
        style={{ height: 60 * unitY, width: 500 * unitX }}
      />
    );

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={message}
      isSpan={false}
      color={colors.all.black}
      style={{
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        wordWrap: "break-word",
        overflow: "hidden",
        backgroundColor: textColors.backgroundColor
      }}
    />
  );
});

export const OldExtraDataEvents = withLiteObserverAndTheme<{
  eventType: string;
  extraData: string;
}>((props) => {
  const { eventType, extraData, theme } = props;
  const { colors } = theme;

  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(extraData);

  let textColors = {
    backgroundColor: "",
    textColor: ""
  };
  if (
    eventType === "APPROVE_DESCRIPTION" ||
    eventType === "REJECT_DESCRIPTION" ||
    eventType === "APPROVE_PEER_DESCRIPTION" ||
    eventType === "REJECT_PEER_DESCRIPTION"
  ) {
    textColors = hasBadWords
      ? {
          backgroundColor: colors.all.red,
          textColor: colors.all.white
        }
      : hasSocialMedia
        ? {
            backgroundColor: colors.all.orange,
            textColor: colors.all.white
          }
        : {
            backgroundColor: colors.all.transparent,
            textColor: colors.all.black
          };
  }

  return eventType === "UPDATE_PICTURE_APPROVE" ||
    eventType === "REJECT_PICTURE" ||
    eventType === "APPROVE_PICTURE" ||
    eventType === "UPDATE_PICTURE_REJECT" ? (
    <Et3Image
      type="ONLINE"
      alt={i18n.get("USER")}
      imageName={`${configuration.pictureUrl}${extraData}`}
      size={200}
      onClick={() => {}}
      style={{}}
    />
  ) : (
    <Et3Text
      fontFamily={"LIGHT"}
      fontSize={16}
      text={`${extraData}`}
      isSpan={false}
      color={textColors.textColor}
      style={{
        backgroundColor: textColors.backgroundColor,
        wordWrap: "break-word",
        width: "100%"
      }}
    />
  );
});

export const ExtraDataEvents = withLiteObserverAndTheme<{
  eventType: string;
  imageSource: string;
  description: string;
  reportID: number;
  investigationCaseID: number;
  temporaryBanUntil: string;
  temporaryBanNumberOfDays: number;
  extraData: string;
}>((props) => {
  const {
    eventType,
    imageSource,
    description,
    reportID,
    investigationCaseID,
    temporaryBanUntil,
    temporaryBanNumberOfDays,
    extraData,
    theme
  } = props;
  const { colors } = theme;

  const reducedDescription = reduce(() => description, "");
  const reducedReportID = reduce(() => reportID, -1);

  const { hasBadWords, hasSocialMedia } =
    checkIfHasBadWordsAndSocialMedia(reducedDescription);

  const textColors = DESCRIPTION_EVENTS.includes(eventType)
    ? hasBadWords
      ? { backgroundColor: colors.all.red, textColor: colors.all.white }
      : hasSocialMedia
        ? {
            backgroundColor: colors.all.orange,
            textColor: colors.all.white
          }
        : {
            backgroundColor: colors.all.transparent,
            textColor: colors.all.black
          }
    : {
        backgroundColor: colors.all.transparent,
        textColor: colors.all.black
      };

  if (PICTURE_EVENTS.includes(eventType)) {
    return (
      <Et3Image
        type="ONLINE"
        alt={i18n.get("USER")}
        imageName={`${configuration.pictureUrl}${imageSource}`}
        size={200}
        onClick={() => {}}
        style={{}}
      />
    );
  }

  const textParts = getExtraDataParts({
    eventType,
    extraData,
    description: reducedDescription,
    reportID: reducedReportID,
    investigationCaseID,
    temporaryBanUntil,
    temporaryBanNumberOfDays
  });

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={0}
      height={0}
      color={colors.all.transparent}
      style={{ width: "100%" }}
      onClick={() => {}}
    >
      {textParts.map((text, index) => (
        <Et3Text
          key={index}
          fontFamily="LIGHT"
          fontSize={16}
          text={text}
          isSpan={false}
          color={textColors.textColor}
          style={{
            backgroundColor: textColors.backgroundColor,
            wordWrap: "break-word",
            width: "100%"
          }}
        />
      ))}
    </ET3Div>
  );
});

export const LinkComponent = withLiteObserverAndTheme<{
  href: string;
  text: string;
  style: CSSProperties;
}>((props) => {
  const { href, text, style } = props;
  const isRecipientColored =
    getCoreHistoryStore().getPageName() === "USER_MESSAGES"
      ? reduce(
          () =>
            getUserMessagesStore().coloredReceipientMessage.get(parseInt(text)),
          false
        )
      : false;

  return (
    <Link
      to={href}
      target="_blank"
      style={{
        backgroundColor: colors.all.transparent,
        ...style
      }}
      aria-disabled={true}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={15}
        text={`${text}`}
        isSpan={false}
        color={
          isRecipientColored
            ? colors.all.vibrantPinkishMagenta
            : colors.all.shadeOfBlueDark
        }
        style={{ textAlign: "center" }}
      />
    </Link>
  );
});

export const HeaderWithTypeField = withLiteObserverAndTheme<{ value: string }>(
  (props) => {
    const { value } = props;
    const isSupervisePage =
      getCoreHistoryStore().getPageName() === "SUPERVISOR_SUPERVISE"
        ? true
        : false;

    const typeColor =
      value === "REJECT_PICTURE" ||
      value === "REJECT_DESCRIPTION" ||
      value === "REJECT_PEER_DESCRIPTION"
        ? colors.all.red
        : value === "APPROVE_PICTURE" ||
            value === "APPROVE_DESCRIPTION" ||
            value === "APPROVE_PEER_DESCRIPTION"
          ? colors.all.green
          : isSupervisePage
            ? "black"
            : "transparent";
    return (
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={20}
        text={getClientReadableText(`${value}`)}
        isSpan={true}
        color={isSupervisePage ? typeColor : colors.all.maastrichtBlue}
        style={{
          width: "100%",
          textAlign: "center",
          wordWrap: "break-word",
          backgroundColor: !isSupervisePage ? typeColor : null
        }}
      />
    );
  }
);

export const ReasonsArrayDisplay = withLiteObserverAndTheme<{
  reasons: string[];
}>((props) => {
  const { theme, reasons } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={60}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        width: "100%"
      }}
      onClick={() => {}}
    >
      {isDefinedArray(reasons) ? (
        reasons.map((reason) => {
          return (
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={12}
              text={isDefinedString(reason) ? `${reason}` : "No Reason"}
              isSpan={false}
              color={colors.all.black}
              style={{
                width: "80%",
                textAlign: "center"
              }}
            />
          );
        })
      ) : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={12}
          text={"No Reason"}
          isSpan={false}
          color={colors.all.black}
          style={{ width: "100%", textAlign: "center" }}
        />
      )}
    </ET3Div>
  );
});

export const AuditedExtraData = withLiteObserverAndTheme<{
  auditedDataType: string;
  auditedPageName: string;
  auditedExtraData: string;
  auditedImageSource: string;
  auditedDescription: string;
  auditedReportID: number;
  auditedInvestigationcCaseID: number;
  auditedTemporaryBanUntil: string;
  auditedTemporaryBanNumberOfDays: number;
}>((props) => {
  const {
    auditedDataType,
    auditedPageName,
    auditedImageSource,
    auditedDescription,
    auditedReportID,
    auditedInvestigationcCaseID,
    auditedTemporaryBanNumberOfDays,
    auditedTemporaryBanUntil,
    auditedExtraData
  } = props;
  if (auditedPageName === "REPORTS") {
    const reducedReportID = reduce(() => auditedReportID, -1);
    return (
      <Link
        to={`/reports?id=${reducedReportID}`}
        target="_blank"
        style={{
          backgroundColor: colors.all.transparent
        }}
        aria-disabled={true}
        onClick={(e) => {
          if (!isPositiveNumber(reducedReportID)) {
            e.preventDefault();
          }
        }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={15}
          text={`${reducedReportID}`}
          isSpan={false}
          color={colors.all.white}
          style={{
            backgroundColor: colors.all.bondiBlue,
            padding: 5,
            borderRadius: 10
          }}
        />
      </Link>
    );
  }
  return (
    <ExtraDataEvents
      eventType={auditedDataType}
      imageSource={auditedImageSource}
      description={auditedDescription}
      reportID={-1}
      temporaryBanUntil={auditedTemporaryBanUntil}
      temporaryBanNumberOfDays={auditedTemporaryBanNumberOfDays}
      investigationCaseID={auditedInvestigationcCaseID}
      extraData={auditedExtraData}
    />
  );
});

export const InvestigationButton = ({
  user_id,
  action_place,
  action_id,
  button_type
}: {
  user_id: number;
  action_place: string;
  action_id: number;
  button_type: "link" | "messages" | "profile";
}) => {
  let hrefVal = ``;
  let buttonText: Ti18nKeys = "EMPTY_STRING";
  let eventName = ``;
  let fromPage: TCorePage = `INVESTIGATION_CASES`;
  if (button_type === "link") {
    buttonText =
      action_place === "USER_ADVANCED"
        ? "GO_TO_USER_ADVANCED"
        : action_place === "CONVERSATIONS"
          ? "CONVERSATIONS"
          : action_place === "REPORTS"
            ? "REPORTS"
            : "EMPTY_STRING";
    eventName =
      action_place === "USER_ADVANCED"
        ? "GO_TO_USER"
        : action_place === "CONVERSATIONS"
          ? "GO_TO_CONVERSATIONS"
          : "GO_TO_REPORT";
    if (isPositiveNumber(user_id)) {
      if (action_place === "USER_ADVANCED") {
        hrefVal = `/users/advanced?id=${user_id}`;
      }
      if (action_place === "CONVERSATIONS") {
        hrefVal = `/users/conversations?senderID=${user_id}&&recipientID=${action_id}`;
      }
      if (action_place === "REPORTS") {
        hrefVal = `/reports?id=${action_id}`;
      }
    }
  } else if (button_type === "messages") {
    buttonText = "GO_TO_MESSAGES";
    hrefVal = `/users/messages?id=${user_id}`;
    eventName = `GO_TO_MESSAGES`;
  } else {
    buttonText = "GO_TO_USER_ADVANCED";
    hrefVal = `/users/advanced?id=${user_id}`;
    eventName = `GO_TO_USER`;
  }
  const eventTypeButtonHidden = buttonText === "EMPTY_STRING";
  return eventTypeButtonHidden ? null : (
    <Et3ATag href={hrefVal} target="_blank" style={{ textDecoration: "auto" }}>
      <Et3Button
        size="MEDIUM"
        isEnabled={true}
        onClick={async () => {
          await getCorePersonalStore().insertAdminEvent({
            eventName,
            fromPage,
            userID: parseInt(`${user_id}`, 10),
            extraData: {}
          });
        }}
        type="GET"
        text={buttonText}
      />
    </Et3ATag>
  );
};

export const ResolveInvestigationCases = withLiteObserverAndTheme<{
  invResolveInvestigationId: number;
  invResolveUserUUID: string;
  invResolveReasons: string[];
}>((props) => {
  const { invResolveInvestigationId, invResolveUserUUID, invResolveReasons } =
    props;

  const reasons = isDefinedArray(invResolveReasons) ? invResolveReasons : [""];

  return (
    <Et3Button
      size="SMALL"
      onClick={async () => {
        await getInvestigationCasesStore().updateInvestigationCase({
          investigationCaseID: parseInt(`${invResolveInvestigationId}`, 10),
          eventName: "RESOLVE_INVESTIGATION_CASE",
          fromPage: "INVESTIGATION_CASES",
          userUUID: invResolveUserUUID,
          extraData: reasons
        });
      }}
      isEnabled={true}
      text={"RESOLVE"}
      type="APPROVE"
    />
  );
});

export const BannedUserDescText = withLiteObserverAndTheme<{
  text: string;
  isFlagged: boolean;
}>((props) => {
  const { text, isFlagged } = props;

  return (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={16}
      text={text}
      isSpan={false}
      color={isFlagged ? colors.all.red : colors.all.black}
      style={{
        justifyContent: "center",
        alignItems: "center",
        wordWrap: "break-word",
        overflow: "hidden",
        width: "100%"
      }}
    />
  );
});

export const HeaderWithSubtitle = withLiteObserverAndTheme<{
  title: string;
  subtitle: string;
}>((props) => {
  const { title, subtitle } = props;

  return (
    <ET3Div
      width={0}
      height={0}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        lineHeight: 1.2,
        width: "100%",
        height: "100%",
        whiteSpace: "normal",
        wordWrap: "break-word"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={14}
        isSpan={true}
        text={title}
        style={{}}
        color={""}
      />
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={10}
        isSpan={true}
        text={subtitle}
        style={{
          wordWrap: "break-word"
        }}
        color={""}
      />
    </ET3Div>
  );
});
